// TODO: think about how to remove the save state bit
import { config } from '@/constants'
import { Reservation, SaunaKind } from '@/use/use-sauna-reservation-system'
import getSavedState from '@/utils/get-saved-state'
import saveState from '@/utils/save-state'
import { format } from 'date-fns'

type SaunaState = {
  reservation: Reservation | null
}

export const state: SaunaState = {
  reservation: getSavedState('sauna.reservation') || null,
}

export const getters = {
  reservation(state: SaunaState) {
    return state.reservation
  },
}

export const mutations = {
  SET_RESERVATION(state: SaunaState, reservation: SaunaState['reservation']) {
    state.reservation = reservation
    saveState('sauna.reservation', state.reservation)
  },
}

export const actions = {
  async makeReservation({ commit, rootState }, {
    saunaKind,
    date,
    time,
    numberOfPeople
  }: { saunaKind: SaunaKind, date: Date, time: string, numberOfPeople: number }) {
    const hyphenatedDate = format(date, 'yyyy-MM-dd') as `${number}-${number}-${number}`


    const url = new URL('/makeReservation', config.saunaReservationSystem.apiUrl)
    url.searchParams.set('type', saunaKind)
    url.searchParams.set('date', hyphenatedDate)
    url.searchParams.set('time', time)
    url.searchParams.set('numPeople', numberOfPeople.toString())

    const jwtToken = rootState.auth.currentUser.jwtToken
    const response = await fetch(url.toString(), {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 200) {
      const data = await response.json()
      commit('SET_RESERVATION', data)
      return { success: true, data }
    }

    return { success: false, data: response }
  },
  async cancelReservation({ commit, rootState }, { bookeoBookingNumber }: { bookeoBookingNumber: string }): Promise<{ success: boolean; errorMessage?: string }> {
    const url = new URL('/cancelReservation', config.saunaReservationSystem.apiUrl)
    url.searchParams.set('reservationNumber', bookeoBookingNumber)

    const jwtToken = rootState.auth.currentUser.jwtToken

    const response = await fetch(url.toString(), {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
      },
    })

    if (response.status === 200) {
      // The backend says it was successfully cancelled
      commit('SET_RESERVATION', null)
      return { success: true }
    }

    if (response.status === 404) {
      // The backend says that no reservation belongs to this member in the first place
      commit('SET_RESERVATION', null)
      return { success: true }
    }

    if (response.status === 401) {
      // The backend says that this member has a different reservation to the one they've asked to cancel
      return { success: false, errorMessage: 'You do not have permission to cancel this reservation. Please ask us for assistance at the front desk.' }
    }

    return { success: false }

  },
  async fetchLatestReservation({ commit, rootState }) {
    const url = new URL('/getLatestReservation', config.saunaReservationSystem.apiUrl)
    const jwtToken = rootState.auth.currentUser.jwtToken
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
      },
    })

    switch (response.status) {
      case 200:
        try {
          const data = await response.json()
          commit('SET_RESERVATION', data)
          return { success: true, data }
        } catch (e) {
          // if we get a 200 but the call to json() fails, we simply can't say success: true. 
          return { success: false, response }
        }
      case 204:
      case 404:
        commit('SET_RESERVATION', null)
        return { success: true }
      default:
        return { success: false, data: response }
    }
  }
}
